import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AgentState {
  isToolPanelExpanded: boolean;
  setIsToolPanelExpanded: (isExpanded: boolean) => void;
}

export const useAgentStore = create<AgentState>()(
  persist(
    (set) => ({
      isToolPanelExpanded: false,
      setIsToolPanelExpanded: (isExpanded) => set(() => ({ isToolPanelExpanded: isExpanded })),
    }),
    {
      name: "agent-store",
      partialize: (state) => ({
        isToolPanelExpanded: state.isToolPanelExpanded,
      }),
    },
  ),
);
